import React from 'react'
import HomeNavBar2 from '../Components/HomeNavBar/HomeNavBar2'
import Footer from '../Components/Footer/Footer'
import Community from '../Components/Community/Community'

const CommunityPage = () => {
  return (
    <div>
        <HomeNavBar2/>
        <Community/>
        <Footer/>
    </div>
  )
}

export default CommunityPage